var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Typography } from '../../foundations/typography';
import { FieldSubText } from '../Forms/Elements/FieldSubText';
import { filteredStringList } from '../../utils/filtered-string-list';
import styles from './LabeledControl.module.scss';
/**
 * @tdr
 */
export var LabeledControl = forwardRef(function (_a, ref) {
    var _b;
    var control = _a.control, className = _a.className, boxed = _a.boxed, label = _a.label, ariaDescribedBy = _a.ariaDescribedBy, errorText = _a.errorText, props = __rest(_a, ["control", "className", "boxed", "label", "ariaDescribedBy", "errorText"]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var name = props.name, onChange = props.onChange, checked = props.checked, disabled = props.disabled, value = props.value, id = props.id, rest = __rest(props, ["name", "onChange", "checked", "disabled", "value", "id"]);
    var hasError = !!errorText;
    var labelId = id && "".concat(id, "-label");
    var errorTextId = id && "".concat(id, "-errorText");
    var describedBy = filteredStringList([hasError && errorTextId, ariaDescribedBy]);
    var controlPropKeys = [
        'name',
        'onChange',
        'checked',
        'value',
        'disabled',
        'id',
    ];
    var controlProps = {};
    controlPropKeys.forEach(function (rewriteProperty) {
        controlProps[rewriteProperty] =
            props[rewriteProperty] !== undefined
                ? props[rewriteProperty]
                : control.props[rewriteProperty];
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("label", __assign({ id: labelId, htmlFor: id, className: cx(styles.label, (_b = {},
                _b[styles.boxed] = boxed,
                _b[styles.isChecked] = checked,
                _b[styles.isDisabled] = disabled,
                _b[styles.hasError] = hasError,
                _b), className) }, rest, { ref: ref }),
            React.cloneElement(control, __assign(__assign({}, controlProps), { 'aria-describedby': describedBy, 'aria-invalid': hasError, 'aria-labelledby': labelId })),
            React.createElement("span", { className: styles.spacer }),
            typeof label === 'string' ? (React.createElement(Typography, { styleAs: checked ? 'paragraphHeading' : 'paragraph', noMargins: true }, label)) : (label)),
        React.createElement(FieldSubText, { id: errorTextId, text: errorText, type: "error" })));
});
//# sourceMappingURL=LabeledControl.js.map